import UploadMediaSection from './UploadMediaSection'
import TextAreaSection from './TextAreaSection'
import ModelSection from './ModelSection'
import SmartEditContent from './SmartEditContent'
import * as Styled from './styled'
import StyleConsistencySection from './StyleConsistencySection'
import { useDispatch, useSelector } from 'react-redux'
import {
  isSmartEditModeSelector,
  isVideoConsistencyFeatureAvailableSelector
} from 'store/selectors'
import ImageStyles from 'containers/SubSidebar/AiImageContent/GenerateTab/Content/ImageStyles'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { useCallback, useEffect } from 'react'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { T } from 'consts/translationKeys'

const GenerateTab = () => {
  const dispatch = useDispatch()
  const isSmartEditMode = useSelector(isSmartEditModeSelector)
  const isConsistencyFeatureAvailable = useSelector(
    isVideoConsistencyFeatureAvailableSelector
  )
  const isFromDifferentProject = useSelector(
    aiVideoSelectors.isFromDifferentProject
  )
  const isConsistencyEnabled = useSelector(
    aiVideoSelectors.isConsistencyEnabled
  )

  const hasItemsInActiveReferenceBucket = useSelector(
    aiVideoSelectors.hasRefItemsInActiveBucket
  )
  const refImageSelectedStyleId = useSelector(
    aiVideoSelectors.refImageSelectedStyleId
  )
  const isRestyling = useSelector(aiVideoSelectors.hasRefItemsInActiveBucket)
  const allStyles = useSelector(aiImageSelectors.styles)
  const restylingStyles = useSelector(aiImageSelectors.restylingStyles)

  const showManualSettings =
    !isConsistencyEnabled || !isConsistencyFeatureAvailable

  const onSetStyleId = useCallback(
    (id?: number) => {
      dispatch(aiVideoThunks.setRefImageSelectedStyleId(id))
    },
    [dispatch]
  )

  useEffect(() => {
    if (!hasItemsInActiveReferenceBucket) {
      dispatch(aiVideoThunks.setRefImageSelectedStyleId(undefined))
    }
  }, [hasItemsInActiveReferenceBucket, dispatch, refImageSelectedStyleId])

  if (isSmartEditMode) {
    return <SmartEditContent />
  }

  return (
    <Styled.GenerateTabContainer>
      {isConsistencyFeatureAvailable && !isFromDifferentProject && (
        <StyleConsistencySection />
      )}
      {showManualSettings && <ModelSection />}
      <TextAreaSection />
      {showManualSettings && (
        <>
          <UploadMediaSection />
          {hasItemsInActiveReferenceBucket && (
            <ImageStyles
              styleId={refImageSelectedStyleId}
              onSetStyleId={onSetStyleId}
              styles={isRestyling ? restylingStyles : allStyles}
              disableFieldLabel
              placeholderText={T.RESTYLE_LABEL}
            />
          )}
        </>
      )}
    </Styled.GenerateTabContainer>
  )
}

export default GenerateTab
